import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VideoPreviewComponent } from './video-preview.component';
import { AngularSvgIconModule } from 'angular-svg-icon';

@NgModule({
  declarations: [
    VideoPreviewComponent,
  ],
  imports: [
    CommonModule,
    AngularSvgIconModule,
  ],
  exports: [
    VideoPreviewComponent,
  ]
})
export class VideoPreviewModule { }
